import logo from "./logo.svg";
import "./App.css";
import Login from "./components/pages/Login";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./components/pages/Dashboard";
import Home from "./components/pages/Home";
import Report from "./components/pages/Report";
import Analysis from "./components/pages/Analysis";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        <Route path="/dashboard" element={<Dashboard />}>
          <Route path="home" element={<Home />}></Route>
          <Route path="report" element={<Report />}></Route>
          <Route path="analysis" element={<Analysis />}></Route>
        </Route>
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{
          fontSize: "14px",
          marginTop: "20px",
          marginRight: "10px",
          marginTop: "10px",
        }}
      />
    </>
  );
}

export default App;
